module.exports = __webpack_public_path__ + "static/5-a095b0dc87bbc7a455561da05c548c3b.jpg";